<template>
    <div class="r-d-loader__container" :class="{ 'r-d-loader__container--overlay': overlay }">
        <img src="/images/shared/Robins-And-Day-Loader-Purple.svg" alt="Loading" class="r-d-loader__svg">
    </div>

</template>

<script>
export default {
    props: {
        overlay: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<style lang="scss" scoped>
.r-d-loader {
    &__container {
        display: flex;
        justify-content: center;

        &--overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.7);
            z-index: 10;
            align-items: center;
        }
    }

    &__svg {
        width: 100%;
        max-width: 150px;
    }
}
</style>